import { Doctors } from "cadendar-shared";
import poster from "../utils/poster";

const prefix = "cadendarRest";
async function getToken(emailOrUsername: string, password: string) {
  return await poster<{ token: string }>(`${prefix}/getToken`, {
    username: emailOrUsername,
    password,
  });
}

const devHost = import.meta.env.VITE_DEV_HOST || "";
async function getConnectedUser(token: string): Promise<Doctors> {
  const response = await fetch(
    `${devHost ? devHost + "/" : ""}${prefix}/getConnectedUserByBearer`,
    {
      mode: "cors",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
    }
  );
  if (response.ok) {
    const json = await response.text();
    return JSON.parse(json);
  } else {
    throw new Error(`invalide json dans getConnectedUser`);
  }
}

export { getToken, getConnectedUser };
